jQuery(function () {
    $('.dropdown-wrapper a.country, .dropdown-wrapper a.my-page').on('click', function(e) {
        e.preventDefault();
        if($(this).hasClass('my-page')) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'ccLogInButton'
            });
        }
        $(this).parent().toggleClass('open');
    });

});

$(document).click(function(e) {
    if($(e.target).is('.country') || $(e.target).is('.my-page')) {
        return false;
    }
    if (!$(e.target).is('.country')) {
        if($('.country').parent().hasClass('open')) {
            $('.country').parent().removeClass('open');
        } 
    }
    if (!$(e.target).is('.my-page')) {
        if($('.my-page').parent().hasClass('open')) {
            $('.my-page').parent().removeClass('open');
        }  
    }
});